import { render } from "./GameChatGPT.vue?vue&type=template&id=0f003fea&scoped=true"
import script from "./GameChatGPT.vue?vue&type=script&lang=js"
export * from "./GameChatGPT.vue?vue&type=script&lang=js"

import "./GameChatGPT.vue?vue&type=style&index=0&id=0f003fea&lang=scss"
import "./GameChatGPT.vue?vue&type=style&index=1&id=0f003fea&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f003fea"]])

export default __exports__